'use strict';

export default function FileExtensionFilter() {
  'ngInject';

  return function (fileName: string = '') {
    return fileName.replace(/.*\./, '');
  };
}
